// extracted by mini-css-extract-plugin
export default {"header":"Homepage_header__ykjoz","grids-container":"Homepage_grids-container__xTAFI","content-container":"Homepage_content-container__Z6r-y"};